export interface WizardStep {
  id: string;
  label: string;
  isValid: boolean;
  isRelevant: boolean;
}
